export class RuntimeInfo {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get runtime() {
        return this.parent;
    }
}
